<template>
	<div class="product">
		<search-firmware
			v-on:addFirmware="addFirmware"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search"
		>
		</search-firmware>
		<add-firmware
			:dialogFirmware="dialogFirmware"
			v-on:cancel="cancel"
			:appFirmware="appFirmware"
		>
		</add-firmware>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="appFirmwareList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="fileName"
					:show-overflow-tooltip="true"
					:label="$t('upgrade.fileName')"
				></el-table-column>
				<el-table-column
					prop="version"
					:label="$t('upgrade.firmwareId')"
				></el-table-column>
				<el-table-column
					prop="notes"
					:show-overflow-tooltip="true"
					:label="$t('appVersion.notes')"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('upgrade.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 100 : 100"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-button
							size="mini"
							v-hasPerm="['upgrade:vmc:edit']"
							@click="editFirmware(scope.row)"
							>{{ $t("common.edit") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				@size-change="sizeChange"
				:page-size="page.pageSize"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import AddFirmware from "_c/upgrade/AddFirmware.vue";
import SearchFirmware from "_c/upgrade/SearchFirmware.vue";
export default {
	name: "Vmc",
	components: {
		SearchFirmware,
		AddFirmware,
	},
	data() {
		return {
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			search: {
				fileName: "",
				version: "",
				startTime: "",
				endTime: "",
			},
			appFirmwareList: [],
			dialogFirmware: false,
			appFirmware: {
				id: "",
				prefix: "",
				version: "",
				url: "",
				fileName: "",
				notes: "",
			},
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.Upgrade.firmware, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.appFirmwareList = res.data.records;
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		addFirmware() {
			this.dialogFirmware = true;
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;

			this.currentChange();
		},
		cancel(dialog, state) {
			this.dialogFirmware = dialog;
			if (state) {
				this.currentChange();
			}
		},
		editFirmware(row) {
			this.dialogFirmware = true;
			Object.keys(this.appFirmware).forEach(key => {
				this.appFirmware[key] = row[key];
			});
		},
	},
};
</script>

<style scoped>
.el-tag--mini {
	margin-right: 5px;
}
</style>
